import React from 'react'

const PostList = () => {
  return (
    <div>PostList</div>
  )
}

export default PostList